import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/GLB_Oxxo_V4.glb";
import ObserverEmitter, { EVENTS } from "../../../../../emitter/Observer";
import { gsap } from "gsap";

export class OxxoMapActvFour extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			// this.Usb = gltf.scene.getObjectByName("Usb", true);
			// this.Caja_Fuerte = gltf.scene.getObjectByName("Caja_Fuerte", true);
			// this.Botella_1 = gltf.scene.getObjectByName("Botella_1", true);
			this.Usb = gltf.scene.getObjectByName("Usb", true);
			this.Estante_Cigarros = gltf.scene.getObjectByName("Estante_Cigarros", true);
			this.Estante_Botelllas = gltf.scene.getObjectByName("Estante_Botelllas", true);
			this.Caja_Fuerte = gltf.scene.getObjectByName("Caja_Fuerte", true);
			this.observerListeners();

			//* iluminacion
			this.Mostrador001 = gltf.scene.getObjectByName("Mostrador001", true);
			this.Piso = gltf.scene.getObjectByName("Piso", true);
			this.Techo = gltf.scene.getObjectByName("Techo", true);
			this.Paredes = gltf.scene.getObjectByName("Paredes", true);
			this.Refri_coca_1 = gltf.scene.getObjectByName("Refri_coca_1", true);
			this.Estructura001 = gltf.scene.getObjectByName("Estructura001", true);
			this.Yelox = gltf.scene.getObjectByName("Yelox", true);
			this.Helado = gltf.scene.getObjectByName("Helado", true);

			const newMaterialPiso = this.Piso.material.clone();
			newMaterialPiso.color.set(0xd6d6d6);
			newMaterialPiso.emissiveIntensity = 2;
			newMaterialPiso.emissive.set("#2E2E2E");
			this.Piso.material = newMaterialPiso;
			const newMaterialTecho = this.Techo.material.clone();
			newMaterialTecho.color.set(0xffffff);
			newMaterialTecho.emissiveIntensity = 2;
			newMaterialTecho.emissive.set("#595959");
			this.Techo.material = newMaterialTecho;
			const newMaterialHelado = this.Helado.material.clone();
			newMaterialHelado.color.set(0xd1d1d1);
			newMaterialHelado.emissiveIntensity = 3.6;
			newMaterialHelado.emissive.set("#5E5E5E");
			this.Helado.material = newMaterialHelado;

			this.Paredes.material.emissiveIntensity = 2;
			this.Refri_coca_1.material.emissiveIntensity = 0.98;
			this.Yelox.material.emissiveIntensity = 2.58;
			this.Estructura001.material.emissive.set("#595959");
			this.Estructura001.material.emissiveIntensity = 1;
			this.Mostrador001.material.emissive.set("#737373");
			this.Mostrador001.material.emissiveIntensity = 2;
		});
	}

	animateUSB() {
		this.animatioUsb = gsap.to(this.Usb.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}
	killAnimateUsb() {
		if (this.animatioUsb) this.animatioUsb.kill();
		this.Usb.material.emissiveIntensity = 1;
	}

	animateBotellas() {
		this.Estante_BotelllasAnimation = gsap.to(this.Estante_Botelllas.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}
	killAnimationBotellas() {
		if (this.Estante_BotelllasAnimation) this.Estante_BotelllasAnimation.kill();
		this.Estante_Botelllas.material.emissiveIntensity = 1;
	}
	animateCigarros() {
		this.Estante_CigarrosAnimation = gsap.to(this.Estante_Cigarros.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}
	killAnimationcigarros() {
		if (this.Estante_CigarrosAnimation) this.Estante_CigarrosAnimation.kill();
		this.Estante_Cigarros.material.emissiveIntensity = 1;
	}

	animateCajaFuerte() {
		this.Caja_FuerteAnimation = gsap.to(this.Caja_Fuerte.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}
	killAnimationCajaFuerte() {
		if (this.Caja_FuerteAnimation) this.Caja_FuerteAnimation.kill();
		this.Caja_Fuerte.material.emissiveIntensity = 1;
	}

	observerListeners() {
		ObserverEmitter.on(EVENTS.subtopicFour.activityTwo.onAnimateUSB, () => {
			this.clearAnimations();
			this.animateUSB();
		});
		ObserverEmitter.on(EVENTS.subtopicFour.activityTwo.onAnimateBotellas, () => {
			this.clearAnimations();
			this.animateBotellas();
		});
		ObserverEmitter.on(EVENTS.subtopicFour.activityTwo.onAnimateCigarros, () => {
			this.clearAnimations();
			this.animateCigarros();
		});
		ObserverEmitter.on(EVENTS.subtopicFour.activityTwo.onAnmateDinero, () => {
			this.clearAnimations();
			this.animateCajaFuerte();
		});
		ObserverEmitter.on(EVENTS.subtopicFour.activityTwo.killAllAnimations, () => {
			this.clearAnimations();
		});
	}

	clearAnimations() {
		this.killAnimateUsb();
		this.killAnimationBotellas();
		this.killAnimationCajaFuerte();
		this.killAnimationcigarros();
	}

	renderAnimations() { }
}
